import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { courses } from "../data/courses";
import { Helmet } from "react-helmet";
import ReactMarkdown from "react-markdown";

function CourseDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const course = courses.find((c) => c.slug === slug);

  if (!course) {
    return (
      <div className="text-red-500 text-center mt-10">
        Không tìm thấy khóa học.
      </div>
    );
  }

  const formatCurrency = (value) =>
    value?.toLocaleString("vi-VN") + " VNĐ";

  const discountPercent =
    course.price_origin && course.price
      ? Math.round(
          ((course.price_origin - course.price) /
            course.price_origin) *
            100
        )
      : 0;

  const savedMoney =
    course.price_origin && course.price
      ? course.price_origin - course.price
      : 0;

  return (
    <>
      <Helmet>
        <title>{course.title} | Trung Tâm Dạy Lái Xe Quốc</title>
        <meta name="description" content={course.short_desc} />
      </Helmet>

      <div className="max-w-3xl mx-auto p-4 bg-white rounded shadow mt-6">
        <h1 className="text-2xl font-bold mb-4 text-center">
          {course.title}
        </h1>

        {/* 🔥 BOX KHUYẾN MÃI CHUYÊN NGHIỆP */}
        <div className="bg-gradient-to-r from-yellow-100 to-yellow-50 p-5 rounded-xl mb-6 shadow-md border border-yellow-300">

          {/* Badge giảm */}
          {discountPercent > 0 && (
            <div className="inline-block bg-red-500 text-white px-3 py-1 rounded-full text-sm font-bold mb-3">
              🔥 Giảm {discountPercent}%
            </div>
          )}

          {/* Giá */}
          <div className="flex items-end gap-3 flex-wrap mb-2">

            {course.price_origin && (
              <span className="text-gray-500 line-through text-lg">
                {formatCurrency(course.price_origin)}
              </span>
            )}

            <span className="text-3xl font-bold text-red-600">
              {formatCurrency(course.price)}
            </span>
          </div>

          {/* Tiết kiệm */}
          {savedMoney > 0 && (
            <div className="text-green-600 font-semibold mb-3">
              💰 Tiết kiệm {formatCurrency(savedMoney)}
            </div>
          )}

          {/* CTA */}
          <div className="flex flex-col sm:flex-row gap-3 mt-4">
            <button
              className="flex-1 bg-red-500 hover:bg-red-600 text-white font-bold py-3 rounded-lg transition duration-300 animate-pulse"
              onClick={() => navigate("/lien-he")}
            >
              🚀 Đăng ký ngay
            </button>

            <a
              href="tel:0786529313"
              className="flex-1 text-center bg-green-500 hover:bg-green-600 text-white font-bold py-3 rounded-lg transition duration-300"
            >
              📞 Gọi tư vấn
            </a>
          </div>

        </div>

        {/* Mô tả ngắn */}
        <p className="text-gray-600 mb-4 italic">
          {course.short_desc}
        </p>

        {/* Nội dung markdown */}
        <div className="prose max-w-none">
          <ReactMarkdown>
            {course.content_md}
          </ReactMarkdown>
        </div>
      </div>
    </>
  );
}

export default CourseDetail;